// src/components/TrackingEnableModal.js
import React, { useEffect, useState } from "react";
import ModalForm from "../delivery/ModalForm"; // Ensure this path is correct
import SettingsServices from "../../services/SettingsServices";
import { useDispatch, useSelector } from "react-redux";
import { setShowMessage } from "../../redux/slices/notificationSlice";
import translations from "../../assets/locals/translations";

const TrackingEnableModal = ({ showModal, setShowTrackingEnableModal }) => {
  const settings = new SettingsServices();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const modalTitle = t.enablelivetrackingmodal || "Enable Live Tracking";
  const description = t.toggletracking || "Toggle to enable or disable live employee tracking.";
  const enableText = t.enabletext || "Enable";
  const disableText = t.disabletext || "Disable";
  const closeButtonText = t.close || "Close";

  const [isTrackingEnabled, setIsTrackingEnabled] = useState(false);
  const [tracking, setTracking] = useState({
    enabledTracking: false,
    trackingInterval: 5,
  });

  const handleCloseModal = () => {
    setShowTrackingEnableModal(false);
  };

  const getUserTracking = async () => {
    try {
      const response = await settings.getUserTracking();
      if (response && response.isSuccess) {
        setTracking(response.tracking);
        setIsTrackingEnabled(response.tracking.enabledTracking);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getUserTracking();
  }, []);

  const handleTracking = async () => {
    try {
      const response = await settings.userTracking({
        status: isTrackingEnabled,
        interval: tracking.trackingInterval,
      });
      if (response && response.isSuccess) {
        dispatch(setShowMessage(response.message));
        setShowTrackingEnableModal(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onToggleTracking = () => {
    setIsTrackingEnabled((prev) => !prev);
  };

  return (
    <ModalForm isOpen={showModal} onClose={handleCloseModal} title={modalTitle}>
      <p>{description}</p>

      <div className="d-flex align-items-center my-3">
        <input
          type="checkbox"
          checked={isTrackingEnabled}
          onChange={onToggleTracking}
          className="form-check-input mx-2"
          style={{ transform: "scale(1.5)" }}
        />
        <span>
          {isTrackingEnabled
            ? `${enableText} ${t.livetracking || "Live Tracking"}`
            : `${disableText} ${t.livetracking || "Live Tracking"}`}
        </span>
      </div>

      <div className="border-top pt-3 d-flex justify-content-end align-items-end mt-3">
        <button onClick={handleTracking} className="btn btn-secondary">
          {t.submit || "Submit"}
        </button>
        <button onClick={handleCloseModal} className="btn btn-secondary ms-2">
          {closeButtonText}
        </button>
      </div>
    </ModalForm>
  );
};

export default TrackingEnableModal;
